import getMemberNodes from 'src/util/mainDataBuilder';

/**
 * Sets the initial proposer trade point ID based on the provided query parameter
 * and the available trade point properties.
 * If the query parameter is provided, it is returned.
 * If there are no trade point properties, the trade point id is not set.
 * If there is only one trade point property, its trade point ID is returned.
 * @param {string} queryProposerTradePointId - The proposer trade point ID from the query parameter.
 * @param {Array<object>} properties - The available trade point properties.
 * @param {Array<string>} eligibleTradePointIds - arary of eligible trade point IDs.
 * @returns {object} - The initial proposer trade point ID, or null if it cannot be determined.
 */
const setInitialProposerTradePointId = (
  queryProposerTradePointId,
  properties,
  eligibleTradePointIds,
) => {
  // if trade point cannot be managed, display a message indicating it
  if (properties?.length === 0) {
    return { proposerTradePointId: null, message: { type: 'noActiveTradePoint' } };
  }

  if (queryProposerTradePointId) {
    if (eligibleTradePointIds?.includes(queryProposerTradePointId)) {
      return { proposerTradePointId: queryProposerTradePointId, message: null };
    }

    return { proposerTradePointId: null, message: { type: 'proposerTradePointIdInvalid' } };
  }

  // if only one trade point can be managed, prefill the form with that trade point
  if (properties?.length === 1) {
    const { meters } = properties[0] || {};
    const meterNodes = getMemberNodes(meters);
    if (meterNodes?.length === 1) {
      return { proposerTradePointId: meterNodes[0]?.tradePointId, message: null };
    }
  }

  return { proposerTradePointId: null, message: null };
};

export default setInitialProposerTradePointId;
